import React from 'react'
import './Team.css'
import { Input, Icon, Button, Form, DatePicker } from 'antd'
import { NavLink, Switch, Route, Redirect } from 'react-router-dom'
import instructionsTeam from '../component/instructionsTeam'
import TeamAppointment from '../TeamAppointment/TeamAppointment'
import LogoTeam from '../LogoTeam/LogoTeam'
import RegisteredTeam from '../RegisteredTeam/RegisteredTeam'
import ShowTeamAppointment from '../ShowTeamAppointment/ShowTeamAppointment'
const FormItem = Form.Item
const { RangePicker } = DatePicker
class Team extends React.Component {
  render() {
    return (
      <div className="home">
        <Switch>
          <Route path="/Main/Team/instructionsTeam" component={instructionsTeam}></Route>
          <Route path="/Main/Team/TeamAppointment" component={TeamAppointment}></Route>
          <Route path="/Main/Team/LogoTeam" component={LogoTeam}></Route>
          <Route path="/Main/Team/RegisteredTeam" component={RegisteredTeam}></Route>
          <Route path="/Main/Team/ShowTeamAppointment" component={ShowTeamAppointment}></Route>
          <Redirect
            from="/Main/Team"
            to="/Main/Team/instructionsTeam"
          ></Redirect>
        </Switch>
      </div>
    )
  }
}
export default Team
